var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { model: _vm.value, size: "small", "label-position": "top" } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 40 } },
        [
          _vm.labels.includes("timeType")
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      class: _vm.hideTimeTypeLabel ? "timeRange" : "",
                      attrs: { label: _vm.$t("dashboard.timeVar") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radioGroup",
                          model: {
                            value: _vm.value.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "type", $$v)
                            },
                            expression: "value.type",
                          },
                        },
                        [
                          _c(
                            "el-radio-button",
                            { attrs: { label: "1", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.month"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "2", name: "type" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("storeComponents.tab.quarter"))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "3", name: "type" } },
                            [_vm._v(_vm._s(_vm.$t("storeComponents.tab.year")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.labels.includes("brand")
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("storeComponents.select.brand") },
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          val: _vm.value.brand,
                          options: _vm.ssbtypeOptions,
                          clearable: false,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.value, "brand", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.labels.includes("time")
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.formatTimeLabel } },
                    [
                      _vm.value.type == "1"
                        ? _c("FormDatePicker", {
                            attrs: {
                              val: _vm.value.value,
                              valueformat: "yyyyMM",
                              type: "month",
                              clearable: false,
                              editable: false,
                              placeholder: _vm.$t(
                                "storeComponents.common.pleaseSelectMonth"
                              ),
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.value, "value", $event)
                              },
                            },
                          })
                        : _vm.value.type == "2"
                        ? _c("FormQuarterPicker", {
                            attrs: {
                              val: _vm.value.value,
                              placeholder: _vm.$t(
                                "storeComponents.common.pleaseSelectQuarter"
                              ),
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.value, "value", $event)
                              },
                            },
                          })
                        : _vm.value.type == "3"
                        ? _c("FormDatePicker", {
                            attrs: {
                              val: _vm.value.value,
                              valueformat: "yyyy",
                              type: "year",
                              clearable: false,
                              editable: false,
                              placeholder: _vm.$t(
                                "storeComponents.common.pleaseSelectYear"
                              ),
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(_vm.value, "value", $event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }